module.exports = __webpack_public_path__ + "static/nz-festival-arts-writers-007eef64d12d899ff1354e58473dd694.png";